import React from "react";
import "./footer.css";
import logo from '../assets/logo.jpg';
import { FaEnvelope, FaPhone } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <img src={logo} alt="Logo" className="logo" />
        <div className="foot-section">
          <h4>श्री वरद विनायक</h4>
          <p>को-ऑप. क्रेडीट सोसायटी लि. डफळापुर</p>
          <p>Reg. No:- Reg. No.: SAN / JAT / RSR / (CR) 2125/2024 Dt. 05/02/2024</p>
        </div>

        {/* <div className="footer-section">
          <h4>Timing</h4>
          <p>सकाळी: <br />८.३० ते दुपारी १२.३०</p>
          <p>सायंकाळी:<br />५.३० ते रात्री ८.३०</p>
        </div> */}

        <div className="footer-section">
          <h4>पत्ता: सांगली रोड पोस्ट ऑफिस जवळ, डफळापुर</h4>
          <p>+91 9373330114 <FaEnvelope style={{ marginLeft: '6px', verticalAlign: 'middle' }} /></p>  
          <p>varadvinayaks940@gmail.com <FaPhone style={{ marginLeft: '6px', verticalAlign: 'middle' }} /></p>
        </div>
      </div>

      <div className="footer-bottom">
        © श्री वरद विनायक को-ऑप. क्रेडीट सोसायटी लि. डफळापुर
      </div>
    </footer>
  );
}

export default Footer;
